




import Vue from 'vue';
// @ts-ignore
import jdenticon from 'jdenticon';

export default Vue.extend({
  props: {
    text: String,
    size: {
      type: Number,
      default: 200,
    },
  },
  watch: {
    text() {
      this.load();
    },
    size() {
      this.load();
    },
  },
  methods: {
    load(): void {
      if (this.text) {
        // tslint:disable-next-line
        const svg = jdenticon.toSvg(this.text, this.size, 0);
        this.$el.innerHTML = svg;
      } else {
        this.$el.innerHTML = '';
      }
    },
  },
  mounted(): void {
    this.load();
  },
});
